export default async function gaClientId() {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (window.ga != null) {
        window.ga(tracker => resolve(tracker.get('clientId')));
      } else {
        resolve(null);
      }
    });
  });
}
